import { render } from "./user-dropdown.vue?vue&type=template&id=0221bece&scoped=true&ts=true"
import script from "./user-dropdown.vue?vue&type=script&lang=ts"
export * from "./user-dropdown.vue?vue&type=script&lang=ts"

import "./user-dropdown.vue?vue&type=style&index=0&id=0221bece&lang=css"
import "./user-dropdown.scss?vue&type=style&index=1&id=0221bece&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0221bece"]])

export default __exports__